import React, { useState } from 'react';
import { ActivityHeaderSectionWithSearchLayout } from 'modules/components/layer32';
import { Button } from '@mui/material';
import { SaveSuperAdminModal } from 'modules/components/layer17';
import { useNavigate } from 'react-router-dom';

export type UsersHeaderSectionProps = {};

export const FC = (props: UsersHeaderSectionProps) => {

  return (
    <ActivityHeaderSectionWithSearchLayout.FC
      title='Super Admin Users'
      searchBar={<></>}
      actionButtons={(
        <ActionButtonsGroup />
      )}
    />

  );
};

type ActionButtonsGroupProps = {};

const ActionButtonsGroup = (props: ActionButtonsGroupProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState<boolean>(false);
  const navigate = useNavigate();

  return (
    <>
      {
        isVisible && (
          <SaveSuperAdminModal.FC
            handleClose={() => setIsVisible(() => false)}
            isVisible
          />

        )
      }
      <Button
        variant='contained'
        onClick={() => {
          setIsVisible(() => true);
        }}
      >
        Add New Super Admin
      </Button>
      <Button
        variant='contained'
        onClick={() => {
          navigate('/');
        }}
      >
        Return to App
      </Button>
    </>

  );
};
